export default {"breadcrumbs":"DfiDj","icon":"_7EbNL","iconArrow":"MiBb3","backText":"onSWv","divider":"vLyp1","breadcrumbsRoute":"RF8dR"};